const eventsEnum = {
  //login events
  LoginScreen: "webview_phoneno_screen_launch",
  LoginScreenClosed: "webview_phoneno_screen_cross_clicked",
  LoginScreenContinue: "webview_phoneno_screen_continue_clicked",
  LoginPhoneNotRegistered: "webview_phoneno_not_registered",
  VerifyOtpScreen: "webview_phoneno_OTP_screen_launch",
  VerifyOtpScreenContinue: "webview_phoneno_otp_screen_contine_clicked",
  VerifyOtpEditNumber: "webview_phoneno_otp_screen_edit_phone_number_clicked",
  VerifyOtpScreenClosed: "webview_phoneno_otp_screen_cross_clicked",
  VerifyOtpResendOtp: "webview_phoneno_otp_screen_resend_otp_clicked",
  LoginScreenUpdatePhone: "webview_phoneno_screen_update_clicked",

  //--------------------------------------------------------------

  //payment events
  PayNowScreen: "webview_pay_now_screen_launched",
  PayNowScreenExit: "webview_pay_now_screen_exit",
  PayNowClicked: "webview_pay_now_clicked",
  TxnCancelled: "txn_cancelled",
  TxnDeclined: "txn_declined",
  TxnFailed: "txn_failed",
  PayNowClosed: "webview_pay_now_screen_cross_clicked",
  PayNowZipCashTnCClicked: "webview_pay_now_screen_t&c_zipcash_clicked",
  PayNowMerchantTnCClicked: "webview_pay_now_screen_merchant_t&c_clicked",
  PPNotAvailInfoIconClicked: "pp_not_avail_info_icon_clicked",
  PPNotAvailBottomSheetLaunched: "pp_not_avail_bottom_sheet_launched",
  PPNotAvailBottomSheetGotItClicked: "pp_not_avail_bottom_sheet_okay_got_it",

  PaymentSuccessRedirect:
    "webview_payment_completed_successful_redirection_screen_launched",
  PaymentSuccessRedirectClosed:
    "webview_payment_completed_successful_redirection_screen_cross_clicked",
  PaymentFailureRedirectClosed:
    "webview_payment_completed_failure_redirection_screen_cross_clicked",
  PaymentFailureRedirect:
    "webview_payment_completed_failure_redirection_screen_launched",
  PaymentFailureScreen:
    "webview_payment_completed_failure_redirection_screen_launched",
  PaymentFailureScreenCancelClicked:
    "webview_payment_failed_screen_cancel_clicked",
  PaymentFailureScreenRetryClicked:
    "webview_payment_failed_screen_retry_clicked",

  PaymentActivateAndPayScreen: "webview_activate_pay_screen_launched",
  PaymentActivateAndPayScreenExit: "webview_activate_pay_screen_exit",
  PaymentActivateAndPayClosed: "webview_activate_pay_screen_cross_clicked",
  PaymentActivateAndPayClicked: "webview_activate_pay_screen_button_click",
  PaymentOTPVerifyClicked: "webview_phoneno_otp_screen_verify_clicked",
  PaymentOTPVerifyNPay: "webview_phoneno_otp_screen_verify_n_pay_clicked",
  PaymentOTPAcceptNPay: "webview_phoneno_otp_screen_accept_n_pay_clicked",

  LoadAndPayScreen: "webview_load_pay_screen_launched",
  LoadAndPayScreenClosed: "webview_load_pay_screen_cross_clicked",
  LoadAndPayScreenPayClicked: "webview_load_pay_screen_pay_clicked",
  LoadAndPayErrorShown: "webview_load_pay_screen_pay_error_shown",

  WalletAutoDebitFlow: "webview_wallet_auto_debit_flow",

  OtpSharingHomePageLoad: "otp_sharing_home_page_loaded",
  OtpSharingTransactionDetailsApiToBeCalled:
    "otp_sharing_transaction_details_api_to_be_called",
  OtpSharingNoOtpFound: "otp_sharing_no_otp_found",
  OtpSharingTransactionDetailsFetched:
    "otp_sharing_transaction_details_fetched",
  OtpSharingFetchingTransactionDetailsFailed:
    "otp_sharing_fetching_transaction_details_failed",
  OtpSharingCopyOtpClick: "otp_sharing_copy_otp_clicked",
  OtpSharingIUnderstandClick: "otp_sharing_i_understand_cta_clicked",
  OtpRaiseConcernClick: "otp_raise_concern_cta_clicked",
  OtpRaiseConcernPageSubmitClick: "otp_raise_concern_page_submit_clicked",
  OtpSharingPageToBeClosed: "otp_sharing_page_to_be_closed",
  otpPageLaunch: "webview_otp_page_launch",
  otpPageExit: "webview_otp_page_exit",
  phoneNoPageLaunch: "webview_enter_phone_no_page_launch",
  phoneNoPageExit: "webview_enter_phone_no_page_exit",

  // EMI events
  emiEligibilityCalled: "emi_eligibility_called",
  emiEligibilityCallFailed: "emi_eligibility_failed",
  emiEligibilityCallSuccess: "emi_eligibility_success",
  emiOptionsPageLaunch: "PP+_EMI_transaction_screen_page_launch",
  emiOptionsPageExit: "PP+_EMI_transaction_screen_page_exit",
  emiOptionsPageErrorShown: "PP+_EMI_transaction_screen_error_shown",
  emiOptionsPageRadioButtonClicked:
    "PP+_EMI_transaction_screen_radio_button_clicked",
  emiOptionsPageHowItWorksClicked:
    "PP+_EMI_transaction_screen_how_it_works_clicked",
  emiOptionsPageViewMoreOptionClicked:
    "PP+_EMI_transaction_screen_view_more_option_clicked",
  emiOptionsPageTxnSuccessPageLaunch:
    "PP+_EMI_transaction_screen_transaction_success_page_launch",
  emiOptionsPageTxnErrorShown:
    "PP+_EMI_transaction_screen_transaction_success_error_shown",
  emiOptionsGotItClicked: "PP+_EMI_transaction_screen_Got_it",
  emiTenureXMonths: "EMI_Tenure_X_months",
  emiTxnMakePayment: "PP+_EMI_transaction_screen_MakePayment",
  emiTxnSuccessScreenGoBackClicked:
    "PP+_EMI_transaction_screen_Sucess_GoBack_clicked",
  emiOtpScreenBackBtnClicked: "PP+_EMI_OTP_screen_back_clicked",
  emiScreenBackBtnClicked: "EMI_screen_back_clicked",
  emiPaymentOptionPageLaunced: "webview_payment_option_page_launched",
  emiPaymentOptionPageExit: "webview_payment_option_page_exit",
  emiPaymentStatusPageLaunched: "webview_payment_status_page_launched",
  emiPaymentStatusPageExit: "webview_payment_status_page_exit",
  emiPayInFull: "EMI_PAY_IN_FULL",

  //Clear Dues and Pay shown
  ClearDuesAndPayScreen: "webview_load_pay/clear_dues_screen_launched",
  ClearDuesAndPayScreenPayClicked:
    "webview_load_pay/clear_dues_screen_load/pay_clicked",
  ClearDuesAndPayScreenDuesClicked:
    "webview_load_pay/clear_dues_screen_clear_dues_clicked",
  ClearDuesAndPayClosed: "webview_load_pay/clear_dues_screen_cross_clicked",
  ClearDuesScreen: "webview_clear_dues_screen_launched",
  ClearDuesScreenClosed: "webview_clear_dues_screen_cross_clicked",

  //Clear Bill
  PostPaidBillScreen: "webview_postpaid_bill_clear_screen_launched",
  PostPaidBillScreenClosed: "webview_postpaid_bill_clear_screen_cross_clicked",
  PostPaidBillScreenClicked:
    "webview_postpaid_bill_clear_screen_clear_dues_clicked",
  PostPaidBillScreenErrorShown:
    "webview_postpaid_bill_clear_screen_error_shown",

  PaymentOptionSelected: "webview_load/payment_option_selected",
  NewUpiSelected: "webview_load/pay_new_UPI_selected",
  SavedUpiSelected: "webview_load/pay_stored_UPI_selected",
  UpiWaitPage: "webview_UPI_accept_request_page_launched",
  UpiWaitPageClosed: "webview_UPI_accept_request_page_cross_clicked",
  UpiWaitPageClosedPopup:
    "webview_UPI_accept_request_page_cross_clicked_popup_shown",
  UpiWaitPageClosedPopupOk:
    "webview_UPI_accept_request_page_cross_clicked_popup_shown_user_clicks_ok",
  UpiWaitPageClosedPopupCancel:
    "webview_UPI_accept_request_page_cross_clicked_popup_shown_user_clicks_cancel",

  SaveCardUnchecked: "webview_load_pay_screen_save_card_unchecked",

  WebPaymentFailedScreenLaunched: "webview_payment_failed_screen_launched",
  WebPaymentFailedCancelClicked: "webview_payment_failed_screen_cancel_clicked",
  WebPaymentFailedRetryClicked: "webview_payment_failed_screen_retry_clicked",

  //Ola Foundation Donation events
  DonationSucccessPageLaunch: "donation_succcess_page_launch",
  DonationPageLaunch: "donation_page_launch",
  DonationPageContributeClick: "donation_page_contribute_click",
  DonationPageSuccessSheetDoneClick: "donation_page_success_sheet_done_click",
  DonationPagePayBtnClick: "donation_page_pay_btn_click",
  DonationPageDonationFailed: "donation_page_donation_failed",
  DonationPageWalletPaySuccess: "donation_page_wallet_pay_success",
  Receipt80GPageLaunch: "receipt80_g_page_launch",
  Receipt80GDetailsSubmitClick: "receipt80_g_details_submit_click",
  Receipt80GDetailsSubmitted: "receipt80_g_details_submitted",
  Receipt80GDetailsSubmissionFailed: "receipt80_g_details_submission_failed",
  Receipt80GSuccessSheetDoneClick: "receipt80_g_success_sheet_done_click",

  //--------------------------------------------------------------

  //credit accept events
  CancelAcceptPage: "credit onboarding dismiss click event",
  AcceptPage: "credit carousel viewed",
  AcceptButtonClicked: "credit onboarding accept click event",
  PPAcceptFailurePage: "credit onboarding failure event",
  PPAcceptSuccessPage: "credit activation screen shown",
  PPActivationConfirmation: "ola credit activation confirmation",
  KycScreenShown: "KYC screen shown",
  DocIdButtonClicked: "OVD button clicked",

  // Postpaid events
  postpaidIntroPageLaunch: "pp_open_to_all_page_view",
  postpaidIntroPageCrossClick: "pp_open_to_all_cross_click",
  postpaidIntroPageOptInClicked: "pp_open_to_all_optin_click",
  postpaidCancelReason: "pp_cancel_reason",
  ppInRideChangeSuccess: "in_ride_change_success",
  ppReActCtaClicked: "pp_react_cta_clicked",
  ppuserNotInAcceptedState: "user_not_in_accepted_state",
  ppOutsideRideSuccess: "outside_ride_success",

  ppActRideStatusApiCalled: "pp_act_ride_status_api_call__web",
  ppActRideStatusApiSuccess: "pp_act_ride_status_api_success__web",
  ppActRideStatusApiFailed: "pp_act_ride_status_api_failed__web",
  ppActSetPPAsDefaultApiCalled: "pp_act_set_pp_as_default_api_call__web",
  ppActSetPPAsDefaultApiSuccess: "pp_act_set_pp_as_default_api_success__web",
  ppActSetPPAsDefaultApiFailed: "pp_act_set_pp_as_default_api_failed__web",
  ppActSetPPAsDefaultApifinallyCalled:
    "pp_act_set_pp_as_default_api_finally_call__web",

  //-------------------
  //pp pitch page events added
  PPPitchPageViewed: "PPPitch_Page_Viewed",
  PPPitchAcceptClicked: "PPPitch_Accept_Clicked",
  PPPitchUserOnboarded: "PPPitch_User_Onboarded",
  PPAcceptError: "PP_Accept_Error",
  PPAlreadyUserError: "PP_already_user_Error",
  PPSubscribeApiCalled: "PP_subscribe_api_called",
  PPAcceptWhatsappDisabled: "PP_accept_whatsapp_disabled",
  PPAcceptWhatsappEnabled: "PP_accept_whatsapp_enabled",

  //--------------------------------------------------------------

  //postpaid events
  waConsentChecked: "whatsapp_consent_checked",
  waConsentUnchecked: "whatsapp_consent_unchecked",
  waConsentFailed: "whatsapp_consent_toggle_failed",
  waConsentSuccess: "whatsapp_consent_toggle_success",
  ActivateAndPayScreen: "Activate and Pay screen launch",
  OtpEntered: "OTP Entered",
  ResendOtp: "Resend OTP clicked",
  MerchantTnCClicked: "T&C clicked",
  PPTnCClicked: "T&C clicked",
  ActivateAndPayClicked: "Activate and Pay clicked",
  PaymentSuccessful: "Payment successful",
  PaymentFailedScreen: "Payment failed screen shown",
  RetryGoBack: "Retry/Go Back clicked",
  UserClickedX: "User clicked X",
  OnboardingScreen2Opened: "Screen 2 opened",
  OnboardingScreen3Opened: "Screen 3 opened",
  MissedDueDateArrowClicked: "Missed Due Date Arrow clicked",
  OnboardingScreen4Opened: "Screen 4 opened",
  WhatsappOptinChecked: "Whatsapp Optin checkbox checked",
  WhatsappOptinUnchecked: "Whatsapp Optin checkbox unchecked",
  OkayGotItClicked: "Okay, Got it! CTA clicked",
  WhatsappReminderSheetOpened: "Whatsapp Reminder sheet opened",
  WhatsappReminderSheetSkipClicked: "Whatsapp Reminder sheet skip clicked",
  WhatsappReminderSheetYesClicked: "Whatsapp Reminder sheet yes clicked",

  //--------------------------------------------------------------
  // insurance events
  InsuranceLandingPageLoad: "landing_page_load",
  InsuranceTCClick: "tc_click",
  Insurance99PlanSelect: "99_plan_select",
  InsuranceTCAccept: "tc_accept",
  InsureMeClicked: "insure_me_click",
  InsuranceTravellerDetailsSubmit: "traveller_details_submit",
  InsuranceOtpSubmit: "otp_submit",
  InsuranceResendOtpClick: "resend_otp_click",
  InsuranceSuccessPageLoad: "success_page_load",
  InsuranceFailurePageLoad: "failure_page_load",

  // PP-all events
  GetStartedClick: "Click on Get Started button",
  BackBtnClick: "Click on the back button",
  VerifyOTPClick: "Click on verify button",
  BackReason: "Reason when back button is clicked",
  NextBtnClick: "Click on Next button",
  InfoBtnClick: "Click on information box",
  StatusOpen: "Status screen opening",
  StatusClose: "Status screen cross button clicked",
  PageLoadSuccess: "Page load success",
  SmsBottomSheetLoad: "SMS permission bottom sheet load",
  SmsBottomSheetCtaClick: "SMS permission bottom sheet CTA is clicked",
  SmsBottomSheetTncClick: "SMS permission bottom sheet T&C is clicked",
  SmsDenyBottomSheetLoad: "SMS permission denied bottom sheet T&C is clicked",
  SmsDenyBottomCtaClick: "SMS permission denied bottom sheet CTA is clicked",
  SmsPermissionGranted: "SMS permission is granted",
  SmsPermissionDenied: "SMS permission is denied",
  SmsPermissionRejected: "SMS permission is denied and do not ask me again",
  SmsDenyPermissionGranted: "SMS permission is granted after being denied",
  SmsDenyPermissionDenied: "SMS permission is denied after being denied",
  SmsDenyPermissionRejected:
    "SMS permission is denied and do not ask me again after being denied"
};

const trustModeEnum = {
  TRUSTED: "TRUSTED",
  NOT_TRUSTED: "NOT_TRUSTED"
};

const postpaidStateEnum = {
  PP_ACTIVATED: "PP_ACTIVATED",
  PP_ENABLED: "PP_ENABLED"
};

const Errors = {
  defaultMessage: "Something Went Wrong!"
};

const ccData = {
  offers: [
    {
      itemKey: "OLA",
      amount: 7,
      text: "Back on Ola rides",
      shortText: "Back on Ola rides",
      color: "#c78020"
    },
    {
      itemKey: "CLEARTRIP_FLIGHTS",
      amount: 5,
      text: "Back on all flight bookings via Cleartrip",
      shortText: "Back on flights",
      color: "#1665c0"
    },
    {
      itemKey: "CLEARTRIP_HOTELS",
      amount: 10,
      text: "Flat discount on all domestic hotel bookings via Cleartrip",
      shortText: "Back on hotels",
      color: "#2ba748"
    },
    {
      itemKey: "ALL_SPENDS",
      amount: 1,
      text: "Back on all other spends",
      shortText: "Back on others",
      color: "#8C15BF"
    }
  ]
};

const vehicleBrands = {
  BIKE: [
    "BAJAJ",
    "HERO",
    "HONDA",
    "TVS",
    "ROYAL ENFIELD",
    "YAMAHA",
    "APRILIA",
    "ATHER",
    "AVON",
    "BAJAJ",
    "BENELLI",
    "BMW",
    "HARLEY DAVIDSON",
    "HERO",
    "HONDA",
    "HYOSUNG",
    "INDUS",
    "KAWASAKI",
    "KTM",
    "MAHINDRA",
    "OTHER",
    "ROYAL ENFIELD",
    "SUZUKI",
    "TVS",
    "UM MOTORCYCLES",
    "VESPA",
    "YAMAHA"
  ],
  CAR: [
    "MARUTI SUZUKI",
    "HYUNDAI",
    "MAHINDRA-RENAULT",
    "TATA",
    "HONDA",
    "TOYOTA",
    "FORD",
    "RENAULT",
    "NISSAN",
    "ASHOK LEYLAND",
    "ASTON MARTIN",
    "AUDI",
    "BENTLEY",
    "BMW",
    "BUGATTI",
    "CHEVROLET",
    "DAEWOO",
    "DATSUN",
    "DC",
    "FERRARI",
    "FIAT",
    "FORCE MOTORS",
    "HINDUSTAN MOTORS",
    "ICML",
    "ISUZU",
    "JAGUAR",
    "JEEP",
    "KOENINSEGG",
    "LAMBORGHINI",
    "LAND ROVER",
    "LEXUS",
    "MAHINDRA",
    "MASERATI",
    "MERCEDES BENZ",
    "MINI",
    "MITSUBISHI",
    "OPEL",
    "PORSCHE",
    "PREMIER",
    "ROLLS ROYCE",
    "SAN",
    "SKODA",
    "SSANGYONG",
    "VOLKSWAGEN",
    "VOLVO"
  ]
};

const DAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

const ADDRESS_TYPES = {
  CURRENT: {
    id: "CURRENT",
    title: "Present address"
  },
  WORK: {
    id: "WORK",
    title: "Office address"
  }
};

const CONTEXT = {
  ID_PROOF: "idproof",
  INCOME_PROOF: "incomeproof",
  ADDRESS: "addresspicker",
  SLOT: "slotpicker"
};
const CONTEXT_KEYS = {
  idproof: "id_proof",
  incomeproof: "income_proof",
  addresspicker: "address_type",
  slotpicker: {
    date: "appt_date",
    time: "appt_time"
  }
};

const apptTimeSlots = {
  "24": [
    "9:00 AM - 10:00 AM",
    "10:00 AM - 11:00 AM",
    "11:00 AM - 12:00 PM",
    "12:00 PM - 1:00 PM",
    "1:00 PM - 2:00 PM",
    "2:00 PM - 3:00 PM",
    "3:00 PM - 4:00 PM",
    "4:00 PM - 5:00 PM",
    "5:00 PM - 6:00 PM",
    "6:00 PM - 7:00 PM"
  ],
  "12": [
    "2:00 PM - 3:00 PM",
    "3:00 PM - 4:00 PM",
    "4:00 PM - 5:00 PM",
    "5:00 PM - 6:00 PM",
    "6:00 PM - 7:00 PM"
  ],
  "14": ["4:00 PM - 5:00 PM", "5:00 PM - 6:00 PM", "6:00 PM - 7:00 PM"]
};

const apptRescheduleReasons = [
  {
    id: "item_list_1",
    title: "I was not available"
  },
  {
    id: "item_list_2",
    title: "Documents were not ready"
  },
  {
    id: "item_list_3",
    title: "Agent did not contact me"
  },
  {
    id: "item_list_5",
    title: "Agent did not arrive on time"
  }
];

const loadingButtonTexts = {
  verify: "Verify",
  verifyAndPay: "Verify & Pay",
  acceptAndPay: "Accept & Pay"
};

const emiScreen = {
  EMI_PAYMENT_ACTIVATE_PAY: "EMI Payment Activate And Pay",
  EMI_AMOUNT_PAY: "EMI Amount Pay",
  EMI_PAYMENT_OPTION: "EMI Payment Option",
  EMI_PAYMENT_STATUS: "EMI Payment Status",
  EMI_OTP_ENTER: "EMI OTP Page",
  EMI_PH_NO_ENTER: "EMI Phone Number Enter Page",
  EMI_MERCHANT_AMOUNT_PAY: "EMI Merchant Amount Pay"
};

const CCSupportEmail = "cards.care@olamoney.com";
const CCSupportPhone = "1860 180 1290";
